class SearchCollectionResults extends HTMLElement {
	connectedCallback() {
		this.loadResults();
	}

	async loadResults() {
		const searchTerm = this.dataset.query?.trim();
		if (!searchTerm) return;

		const url = `${routes.predictive_search_url}?q=${encodeURIComponent(
			searchTerm
		)}&resources[type]=collection&resources[limit]=10&resources[limit_scope]=each&section_id=search-collection-results`;

		try {
			const response = await fetch(url);
			if (!response.ok) {
				throw new Error(`Collection search failed: ${response.status}`);
			}

			const responseText = await response.text();
			const section = new DOMParser()
				.parseFromString(responseText, "text/html")
				.querySelector("#shopify-section-search-collection-results");
			const resultsMarkup = section?.innerHTML.trim();

			if (!resultsMarkup) return;

			this.innerHTML = resultsMarkup;
			this.hidden = false;
		} catch (_error) {
			this.hidden = true;
		}
	}
}

customElements.define("search-collection-results", SearchCollectionResults);
